<template>
  <div class="allocationDetail">
    <el-form ref="form" v-loading="loading" :model="form" class="baseInfoForm">
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              合同编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.contractNum }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              项目名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.projectName }}
            </div>
          </div>
        </div>
      </div>
      <div class="rj-row">
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              供货单位：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.supplyUnit }}
            </div>
          </div>
        </div>
        <div class="rj-col-2">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              订货单位：
            </div>
            <div class="rj-baseinfo__item">
              {{ form.orderUnit }}
            </div>
          </div>
        </div>
      </div>
      <div class="tab-title">
        分配明细
      </div>
      <el-table :data="dataList" border style="width: 100%" :summary-method="getSummaries" show-summary>
        <el-table-column type="index" width="70" label="序号" fixed="left" align="left" />
        <el-table-column prop="telegraphicTransferNum" label="电汇底单编号" align="left" />
        <el-table-column prop="orderSales" label="订单金额" align="right" header-align="left" />
        <el-table-column prop="assignAmount" label="已分配金额" align="right" header-align="left" />
        <el-table-column prop="usedScale" label="已分配金额比例" align="right" header-align="left" />
        <el-table-column prop="createBy" label="分配人" align="left" />
        <el-table-column prop="createTime" label="分配日期" align="left" />
        <el-table-column prop="state" label="状态" align="left" />
      </el-table>
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              申请撤销理由： <span>{{ reason }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--<el-button type="primary" @click="checkOut" :loading="isErpLoading">点击校验ERP发货情况</el-button>-->
      <span style="margin-left:10px ;color:red">{{ checkOutStr }}</span>
      <div class="tab-title">
        发货单明细
      </div>
      <el-table :data="contractDeliveryList" border style="width: 100%" :summary-method="getSummaries" show-summary>
        <el-table-column type="index" width="70" label="序号" />
        <el-table-column prop="orderNum" label="ERP订单编号" align="left" />
        <el-table-column prop="requestNumber" label="发货单号" align="left" />
        <el-table-column prop="deliveryAmount" label="发货金额" align="left" />
        <el-table-column prop="deliveryDate" label="发货日期" align="left" />
      </el-table>
      <div style="margin:10px">
        审批意见：
      </div>
      <el-input v-model="causeRevocation" type="textarea" maxlength="100" />
    </el-form>
  </div>
</template>

<script>
import { distributionDetailView, distributionDetailViewThh, getContractDelivery, isShipped } from '@/API';
import { numAdd } from '../../../../libs/util';
export default {
  name: 'AllocationDetail',
  data () {
    return {
      form: {},
      loading: false,
      dataList: [],
      contractDeliveryList: [],
      tableData: [],
      reason: '',
      causeRevocation: '',
      isErpLoading: false,
      checkOutStr: ''
    };
  },
  mounted () {
    this.initData();
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    // 是否退换货
    thh: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    initData () {
      this.loading = true;
      const api = this.thh ? distributionDetailViewThh : distributionDetailView;
      api(this.id).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.form = json.data;
          this.reason = json.data.reason;
          this.dataList = json.data.assignDetailVOList;
          this.tableData = json.data.telFundManagementApprovalRecords;
          this.getContractDeliveryData();
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    getContractDeliveryData () {
      getContractDelivery({
        contractNum: this.form.contractNum
      }).then(res => {
        if (res.data.status !== '200') return;
        this.contractDeliveryList = res.data.data;
      });
    },
    checkOut () {
      this.isErpLoading = true;
      isShipped(this.form.contractNum).then((res) => {
        this.isErpLoading = false;
        let json = res.data;
        if (json.status === '200') {
          if (json.data) {
            this.checkOutStr = '可撤销';
            this.$emit('onStatus', true);
          } else {
            this.checkOutStr = '不可撤销';
            this.$emit('onStatus', false);
          }
        } else {
          this.checkOutStr = '';
          this.$emit('onStatus', false);
        }
      }).catch(() => {
        this.checkOutStr = '';
        this.isErpLoading = false;
        this.$emit('onStatus', false);
      });
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.orderSales();
        }
        if (column.label === '已分配金额') {
          sums[index] = this.assignAmount();
        }
        if (column.label === '发货金额') {
          sums[index] = this.deliveryAmountTotal();
        }
      });
      return sums;
    },
    orderSales () {
      let cont = 0;
      this.dataList.forEach((item) => {
        cont = numAdd(cont, Number(item.orderSales));
      });
      return cont.toFixed(2);
    },
    assignAmount () {
      let cont = 0;
      this.dataList.forEach((item) => {
        cont = numAdd(cont, Number(item.assignAmount));
      });
      return cont.toFixed(2);
    },
    deliveryAmountTotal () {
      let cont = 0;
      this.contractDeliveryList.forEach((item) => {
        cont = numAdd(cont, Number(item.deliveryAmount));
      });
      return cont.toFixed(2);
    }
  }
};
</script>

<style scoped>
.tab-title{
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
}
</style>
